import axios from 'axios';
import { DISCOUNT_API } from 'Constants';

export async function removeDiscountFromTransaction(
	transactionId: string,
	discountId: string,
	eventBooking: boolean,
	forCheckIn: boolean,
) {
	return axios.post(
		`${DISCOUNT_API}/remove-discount-from-transaction?transactionId=${transactionId}&discountId=${discountId}&eventBooking=${eventBooking}&forCheckIn=${forCheckIn}`,
		{
			validateStatus: () => true,
		},
	);
}
